import { Link as RouterLink, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { faker } from '@faker-js/faker';
// @mui
import { styled } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { max } from 'lodash';

import {
  Card,
  Stack,
  Avatar,
  Button,
  Container,
  Typography,
  Grid,
  Item,
  Box,
  Link,
  Divider,
  CardHeader,
} from '@mui/material';

import Iconify from '../../components/Iconify';
// components
import Page from '../../components/Page';
import Loading from '../../components/loading';

import { getReq } from '../../data/ApiReq';
import API_URL from '../../data/ApiUrl';

export default function News() {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const params = useParams();

  const getData = async () => {
    setLoading(true);

    const res = await getReq({ url: `/news/companyDetails/${params.id}` });
    if (!res.error) {
      setNewsList(res.data);
    }
    console.log(res.data);

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return (
      <Page title="Company Details">
        <Loading />
      </Page>
    );
  }

  return (
    <Page title="Company Details">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" mb={5}>
          {/* <Typography variant="h4" gutterBottom>
                        {newsList.title}
                    </Typography> */}

          <Button
            variant="text"
            component={RouterLink}
            to={`/dashboard/companyDetails`}
            startIcon={<Iconify icon={'material-symbols:arrow-back-rounded'} />}
            color={'primary'}
          >
            List Company Details
          </Button>
        </Stack>

        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid item xs={12}>
            <Card sx={{ paddingRight: 5, paddingLeft: 5 }}>
              <Stack spacing={2}>
                <Grid container spacing={2} m={2}>
                  <Grid item xs={12}>
                    <Typography variant="h3" gutterTop mb={1}>
                      {newsList.title}
                    </Typography>
                    <div
                      className="user-img1"
                      style={{
                        backgroundImage: `url(${API_URL.img_url}/api/uploads/images/${newsList?.image?.ogUrl})`,
                      }}
                    />
                  </Grid>
                  <Grid item xs={10} mt={5} textAlign={'start'}>
                    <p className="news-desc" dangerouslySetInnerHTML={{ __html: newsList.description }} />
                    {/* <div dangerouslySetInnerHTML={{__html: newsList.description}}/> */}
                  </Grid>
                </Grid>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
